import React, { useMemo, createContext, useContext, useEffect } from "react";
import { useBrowserLocation, useSearch } from "wouter/use-browser-location";
import { ParamsContext, buildPathParams } from "./params";
const RouterConfigContext = /*#__PURE__*/createContext([]);
export const LocationHooksContext = /*#__PURE__*/createContext({
  locationHook: useBrowserLocation,
  searchHook: useSearch,
  backHook: () => () => {
    var _window, _window$back;
    return (_window = window) === null || _window === void 0 || (_window = _window.history) === null || _window === void 0 || (_window$back = _window.back) === null || _window$back === void 0 ? void 0 : _window$back.call(_window);
  }
});
export const useLocation = () => {
  const {
    locationHook
  } = useContext(LocationHooksContext);
  return locationHook();
};
export const useSearchQuery = () => {
  const {
    searchHook
  } = useContext(LocationHooksContext);
  return searchHook();
};
export const useBack = () => {
  const {
    backHook
  } = useContext(LocationHooksContext);
  return backHook();
};
export const useFindRouterConfig = () => {
  const config = useContext(RouterConfigContext);
  return path => config.find(({
    pattern
  }) => pattern.test(path));
};
export const useOnLocationChange = callback => {
  const [location] = useLocation();
  useEffect(() => {
    callback(location);
  }, [location, callback]);
};
export const usePathname = () => {
  const [location] = useLocation();
  return location;
};
export const usePathDefinition = () => {
  const findRouterConfig = useFindRouterConfig();
  const [location] = useLocation();
  const config = findRouterConfig(location);
  return config === null || config === void 0 ? void 0 : config.pathDefinition;
};
export const Router = ({
  config,
  Component404 = () => null
}) => {
  const sharedConfig = useMemo(() => {
    return config.map(({
      Component: _Component,
      ...rest
    }) => rest, []);
  }, [config]);
  const [location] = useLocation();
  const item = config.find(({
    pattern
  }) => pattern.test(location));
  const Page = (item === null || item === void 0 ? void 0 : item.Component) || Component404;
  const pathParams = item ? buildPathParams(item, location) : {};
  return /*#__PURE__*/React.createElement(RouterConfigContext.Provider, {
    value: sharedConfig
  }, /*#__PURE__*/React.createElement(ParamsContext.Provider, {
    value: {
      pathParams
    }
  }, /*#__PURE__*/React.createElement(Page, null)));
};